// Default API host (all requests go to be.awarenow.ai unless overridden at build time).
// Optional: set REACT_APP_BACKEND_BASE_URL in .env.production (e.g. http://127.0.0.1:8000 for local).
const raw = process.env.REACT_APP_BACKEND_BASE_URL;
const BACKEND_BASE_URL =
  raw != null && String(raw).trim() !== ''
    ? String(raw).replace(/\/$/, '')
    : 'https://be.awarenow.ai';

const YOUTUBE_API_KEY="AIzaSyCm-yCYmB0Bb1Wg1b6m5SfbL5Hdi-Vto9w"
const FRONTEND_URL="https://panel.innovicloud.com/app/manage"

export  {BACKEND_BASE_URL, YOUTUBE_API_KEY, FRONTEND_URL};
